module.exports = __webpack_public_path__ + "img/Peeling Plating.d4323167.png";